// modal/detail/ui/PillIcon.jsx
import React from 'react';
import Icon from '@mui/material/Icon';
import MDBox from 'components/MDBox';
import { TONES } from './constants';

export function PillIcon({ icon, tone = 'teal' }) {
  const t = TONES[tone] || TONES.teal;

  return (
    <MDBox
      sx={{
        width: 40,
        height: 40,
        borderRadius: '14px',
        display: 'grid',
        placeItems: 'center',
        background: t.bg,
        color: t.fg,
        border: '1px solid rgba(0,0,0,.06)',
        flex: '0 0 auto',
      }}
    >
      <Icon sx={{ fontSize: 20 }}>{icon}</Icon>
    </MDBox>
  );
}
